import React, { useState } from 'react';
import { Stack} from '@mui/material';
import AuthInput from '../../components/Input/AuthInput';
import AuthButton from '../../components/Button/AuthButton';
import VerticalGap from '../../components/Gap/VerticalGap';
import LabelButton from '../../components/Button/LabelButton';
import useAppNavigation from '../../hooks/useAppNavigation';
import { AuthApi } from '../../services/auth';
import useFormUpdateHelper from '../../hooks/useInputHelper';
import { FormField } from '../../utils/formSchema';
import { useFieldHasError } from '../../hooks/useFieldHasError';

interface ForgotPasswordProps {
    onMainBtnClick: () => void;
    onLabelButtonClick: () => void;
    pageProps: any;
}


interface Iform extends FormField<{ email:string}> {
    submitAttempt?: boolean;
  }
const ForgotPassword: React.FC<ForgotPasswordProps> = ({pageProps }) => {

    const appNavigation = useAppNavigation();
    const goLoginPage=()=>appNavigation({path:"/auth",isSibling: true})
    const [form, upDateForm] = useState<Iform>({email:{value:'',isValid:false}});  
    const fieldHasError = useFieldHasError<Iform>(form);
    const handleFormUpdate = useFormUpdateHelper<Iform>(upDateForm);
    const [isProcessing, setProcess] = useState<boolean>(false);


    const sendPassRequest=async ()=>{
        upDateForm((prev)=>({...prev,submitAttempt:true}))
        if(form.email.isValid){
            setProcess(true);
            const res= await AuthApi.passwordResetRequest(form.email.value);
            setProcess(false);
            alert(res.message);
        }
      
    }
    return (
        <Stack>
            <AuthInput value={form.email.value} type="email"  onChange={handleFormUpdate('email','email')}
            error={fieldHasError('email')} errorMessage={form.email.errorMessage}/>
            <VerticalGap height={20} />
    
            <Stack direction={'row'} gap={3} height={40}>
                <AuthButton
                    title={pageProps?.BtnText}
                    size={pageProps?.BtnType}
                    showIcon={pageProps?.BtnIcon}
                    onPress={sendPassRequest}
                    loading={isProcessing}
                />
                <LabelButton
                    onPress={goLoginPage}
                    label={pageProps.infoLabelIconText}
                    direction={pageProps.labelDirection}
                />
            </Stack>
        </Stack>
    );
};

export default ForgotPassword;
